<template>
  <v-card>
    <v-card-text>
      <h3>Force</h3>
      <convert-box></convert-box>
    </v-card-text>
  </v-card>
</template>

<script>
import ConvertBox from '../components/ConvertBox'

export default {
  components: { ConvertBox },
  data() {
    return {
      unit: [
        {
          text: 'attonewton',
          val: 1
        },
        {
          text: 'centinewton',
          val: 1e-17
        },
        {
          text: 'decigram-force',
          val: 1.019716213e-16
        },
        {
          text: 'decinewton',
          val: 1e-18
        },
        {
          text: 'dekagram-force',
          val: 1.019716213e-18
        },
        {
          text: 'dekanewton',
          val: 1e-20
        },
        {
          text: 'dyne (dyn)',
          val: 1e-14
        },
        {
          text: 'exanewton',
          val: 1e-36
        },
        {
          text: 'femtonewton',
          val: 0.001
        },
        {
          text: 'giganewton (GN)',
          val: 1e-27
        },
        {
          text: 'gram-force',
          val: 1.019716213e-17
        },
        {
          text: 'hectonewton',
          val: 1e-21
        },
        {
          text: 'joule / meter (J/m)',
          val: 1e-19
        },
        {
          text: 'kilogram-force (kgf)',
          val: 1.019716e-20
        },
        {
          text: 'kilonewton (kN)',
          val: 1e-22
        },
        {
          text: 'kilopond (kp)',
          val: 1.019716e-20
        },
        {
          text: 'kip (kip)',
          val: 2.248e-23
        },
        {
          text: 'meganewton',
          val: 1e-24
        },
        {
          text: 'megapond',
          val: 1.019716213e-23
        },
        {
          text: 'micronewton (µN)',
          val: 1e-13
        },
        {
          text: 'millinewton (mN)',
          val: 1e-16
        },
        {
          text: 'nanonewton (nN)',
          val: 1e-10
        },
        {
          text: 'newton (N)',
          val: 1e-19
        },
        {
          text: 'ounce-force (ozf)',
          val: 3.5969431019e-19
        },
        {
          text: 'petanewton',
          val: 1e-33
        },
        {
          text: 'piconewton',
          val: 1e-7
        },
        {
          text: 'pond',
          val: 1.019716213e-17
        },
        {
          text: 'pound-force (lbf)',
          val: 2.2480894387e-20
        },
        {
          text: 'poundal (pdl)',
          val: 7.2330140801e-19
        },
        {
          text: 'sthene (sn)',
          val: 1e-22
        },
        {
          text: 'teranewton',
          val: 1e-30
        },
        {
          text: 'ton-force (long)(tnf)',
          val: 1.0036113566e-23
        },
        {
          text: 'ton-force (metric)(tnf)',
          val: 1.019716213e-23
        },
        {
          text: 'ton-force (short)(tnf)',
          val: 1.1240447194e-23
        },
        {
          text: 'yoctonewton',
          val: 1000000
        },
        {
          text: 'yottanewton',
          val: 1e-42
        },
        {
          text: 'zeptonewton',
          val: 1000
        },
        {
          text: 'zettanewton',
          val: 1e-39
        }
      ]
    }
  },
  created() {
    this.$store.dispatch('setUnit', this.unit)
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// force.vue?3a72bb92